import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input
} from '@angular/core';

@Component({
  selector: 'ls-cr-divider',
  template: ``,
  styleUrls: ['./cirrus-divider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CirrusDividerComponent {
  @HostBinding('class.cr-divider--dotted')
  @Input()
  public dotted = false;
}
